<div class="container-fluid">
    <div class="row">
        <div class="col-xs-12 col-md-12 col-lg-12">
            <div class="finzy-row1">
                <div>
                    <img [src]="rowOne.failureLogo" alt="success logo" />
                </div>
                <div class="payment-failed">
                    <p>{{rowOne.failureMsg}}</p>
                </div>
                <div class="payment-failed-discription">
                    <p [innerHTML]="rowOne.failureInfoMsg"></p>
                </div>
            </div>

            <div class="row d-flex justify-content-center">
                <div class="col-sm-12 col-md-6">
                    <table class="table table-bordered">
                        <tbody>
                            <tr *ngFor="let val of rowTwo">
                                <ng-container *ngIf="val.rowName && val.rowValue">
                                    <td class="table-left">{{val.rowName}}</td>
                                    <td class="table-right">
                                        <app-horizontal-loader *ngIf="val.rowValue === undefined">
                                        </app-horizontal-loader>
                                        <strong>{{val.rowValue}}</strong>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="finzy-row3" *ngIf="showTemplateButton">
                <button class="try-again-btn" [routerLink]="['/payment/initiate']">{{templateButtonText}}</button>
            </div>
        </div>
    </div>
</div>